function timerFlash(obj, intDiff) {
    let day = 0,
        hour = 0,
        minute = 0,
        second = 0;
    intDiff = intDiff - 0;
    if (intDiff > 0) {
        hour = Math.floor(intDiff / 1000 / 60 / 60);
        minute = Math.floor((intDiff / 1000 / 60) % 60);
        second = Math.floor((intDiff / 1000) % 60);
    }
    const padZero = (value) => (value < 10 ? "0" + value : value);
    $(obj).find(".flash-deals_valH").text(padZero(hour));
    $(obj).find(".flash-deals_valD").text(padZero(minute));
    $(obj).find(".flash-deals_valS").text(padZero(second));
}

document.addEventListener('DOMContentLoaded', function () {
    const newdate = new Date();
    const s_year = newdate.getFullYear();
    const s_month = newdate.getMonth() + 1;
    const s_day = newdate.getDate();
    const s_time = newdate.toLocaleTimeString();
    console.log(s_time);
    const brandDay_start_time = s_year + "/" + s_month + "/" + s_day + " " + s_time;
    const brandDay_end_time = s_year + "/" + s_month + "/" + s_day + " " + "23:59:59";
    const startTime = new Date(brandDay_start_time);
    const endTime = new Date(brandDay_end_time);
    let endAllTime = endTime.getTime() - newdate;
    let limistTime = setInterval(function () {
        if (endAllTime > 0) {
            endAllTime = endAllTime - 1000;
            timerFlash(".flash-deals_box", endAllTime);
        }
    }, 1000);
});
